<div class="form-group">
  <div class="borrower-attribute-name">
    <label [attr.for]="'ba-' + field.alias" class="font-weight-bold small">
      {{ field.name }}
    </label>
  </div>
  <div [ngSwitch]="field.type">
    <ba-boolean
      *ngSwitchCase="'bool'"
      [field]="field"
      [disabled]="disabled"
      [form]="form">
    </ba-boolean>
    <ba-number
      *ngSwitchCase="'number'"
      [field]="field"
      [disabled]="disabled"
      [form]="form">
    </ba-number>
    <ba-multiselect
      *ngSwitchCase="'multiselect'"
      [field]="field"
      [disabled]="disabled"
      [form]="form">
    </ba-multiselect>
    <ba-select
      *ngSwitchCase="'select'"
      [field]="field"
      [disabled]="disabled"
      [form]="form">
    </ba-select>
    <ba-currency
      *ngSwitchCase="'currency'"
      [field]="field"
      [disabled]="disabled"
      [form]="form">
    </ba-currency>
    <ba-text
      *ngSwitchCase="'text'"
      [field]="field"
      [disabled]="disabled"
      [form]="form">
    </ba-text>
    <ba-textarea
      *ngSwitchCase="'textarea'"
      [field]="field"
      [form]="form">
    </ba-textarea>
    <ba-ssn
      *ngSwitchCase="'ssn'"
      [field]="field"
      [disabled]="disabled"
      [form]="form">
    </ba-ssn>
    <ba-address
      *ngSwitchCase="'address'"
      [field]="field"
      [disabled]="disabled"
      [form]="form">
    </ba-address>
    <ba-date
      *ngSwitchCase="'date-input'"
      [field]="field"
      [disabled]="disabled"
      [form]="form"
      [type]="'date'">
    </ba-date>
    <ba-date
      *ngSwitchCase="'date-month-year'"
      [field]="field"
      [disabled]="disabled"
      [form]="form"
      [type]="'month'">
    </ba-date>

  </div>
</div>
